if(!customElements.get('header-drawer')) {
  customElements.define(
    'header-drawer',
    class HeaderDrawer extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.header = this.parentNode;
        this.triggers = document.querySelectorAll('[data-drawer-trigger]');
        this.initTriggers();
      }

      initTriggers() {
        if(!this.triggers?.length > 0) {
          return console.error('An error ocurred while trying to init header triggers, no header drawer triggers was found.');
        }

        this.triggers.forEach(trigger => {
          trigger.addEventListener('click', () => {
            this.toggle();
            this.toggleHeaderButtons();
          })
        });
      }

      toggle() {
        this.classList.toggle('open');
        document.documentElement.classList.toggle('menu-open');
      }

      toggleHeaderButtons() {
        const headerButtons = this.header.querySelector('.header__buttons');
        if(!headerButtons) return;

        headerButtons.classList.toggle('menu-open');
      }
    }
  );
}